import React from 'react';
import Swal from "sweetalert2";

import { useTranslation } from "react-i18next";

import {
    TabContent, Nav, NavItem, NavLink, Button
} from "reactstrap";

export default function ReportTabFrag(props) {
    const { data, isConfiguration, modelFctManager, finalizeModel, triggerSelection, showActionBar } = props;

    const { t } = useTranslation();
    const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };

    const [shouldRender, setShouldRender] = React.useState(false);
    const [selectedTab, setSelectedTab] = React.useState("1");

    React.useEffect(() => {
        data.childRendered = 0;
        if (isConfiguration && modelFctManager && modelFctManager.commonRenderProc) modelFctManager.commonRenderProc(data);
    }, [props]);
    if (!isConfiguration && modelFctManager && modelFctManager.commonRenderProc) modelFctManager.commonRenderProc(data);

    data.functionManager = {};
    data.functionManager.getSelectedTab = () => {
        var filteredTemplate = data.templates.filter(template => parseInt(selectedTab) === template.tabIndex);
        return filteredTemplate?.length ? filteredTemplate[0] : null;
    };
    data.functionManager.finalizeModel = finalizeModel;
    data.functionManager.getParentProps = () => { return null; };
    data.functionManager.rerender = (forceChild) => {
        setShouldRender(!shouldRender);
        if (forceChild) {
            data.templates.forEach((child) => {
                child?.functionManager?.rerender(true);
            });
        }
    };

    var frameClass = "";
    var frameStyle = {};//{ overflowY: "auto", overflowX: "hidden" };
    var navStyle = {};
    var childStyle = { overflowY: "auto", overflowX: "hidden" };
    if (data.hidden) {
        if (isConfiguration) {
            frameClass += " config-hidden";
        }
        else {
            frameClass += " d-none";
        }
    }

    var shouldInterrupt = false;
    if (data.checkRights) {
        var hasRights = modelFctManager.checkRights(data.checkRights.entity, data.checkRights.rights);
        if (!hasRights) {
            switch (data.checkRights.action) {
                case "invisible":
                    frameStyle.visibility = "hidden";
                    break;
                case "disabled":
                    data.disabled = true;
                    break;
                case "interrupt":
                    shouldInterrupt = true;
                    break;
                default:
                    if (!hasRights) frameClass += " d-none";
                    break;
            }
        }
    }

    var navColor = "";
    var navSelectedColor = "";

    var design = data.customDesign?.design;
    data.mergedDesign = design;
    if (design) {
        Object.assign(childStyle, modelFctManager.setCustomBackground(design, data));
    }

    var designInput = data.customDesign?.designInput;
    if (designInput) {
        Object.assign(navStyle, modelFctManager.setCustomBackground(designInput, data));

        if (designInput.fontColor) {
            navColor = modelFctManager.getRgbaFromHex(designInput.fontColor);
            navSelectedColor = modelFctManager.getRgbaFromHex(designInput.fontColor.replace("#FF", "#99"));
        }
    }
    var designTitle = data.customDesign?.designTitle;
    if (designTitle) {
        if (designTitle.fontColor) navSelectedColor = modelFctManager.getRgbaFromHex(designTitle.fontColor);
    }


    var actionBarData;
    var actionBarBackColor = "#0099CC";
    var actionBarFontColor = "#FFFFFF";
    if (data.templates?.length && data.templates[0].categories?.length && data.templates[0].categories[0].headers?.length) {
        var groupSystem = data.templates[0].categories[0].headers[0].groups?.filter(g => g.groupSubName === "system");
        if (groupSystem && groupSystem.length) {
            var actionBar = groupSystem[0].items.filter(item => item.groupSubName === "actionBarMain");
            if (actionBar?.length) {
                actionBarData = actionBar[0];
                if (actionBarData?.customDesign?.design?.backColor) actionBarBackColor = modelFctManager.getRgbaFromHex(actionBarData.customDesign.design.backColor) || actionBarBackColor;
                if (actionBarData?.customDesign?.design?.fontColor) actionBarFontColor = modelFctManager.getRgbaFromHex(actionBarData.customDesign.design.fontColor) || actionBarFontColor;
            }
        }
    }



    var childs = [];
    if (data.templates) {
        childs = data.templates.map((child, index) => {
            return modelFctManager.componentTyped(child, { parentData: data, childs: data.templates, parentDisabled: data.disabled ? true : false, tabIndex: index+1 });
        });
    }
    data.childCount = childs.length;
    data.countTabIndex = 0;
    return shouldInterrupt ? "" : <div data-name="ReportTabFrag" data-element={data.objType} className={`d-flex flex-column w-100 h-100 ${frameClass}`} style={frameStyle} onClick={(e) => { modelFctManager.setSelected(); }}>
        {(isConfiguration || showActionBar) ? <div className="p-2 ps-3" style={{ backgroundColor: actionBarBackColor, color: "white", minHeight: "40px" }}><i className="fa fa-bars fa-lg me-4"></i><span className="" style={{ fontSize: "19px", color: actionBarFontColor }}>{actionBarData?.title || "Titre Module"}</span><i className="fa fa-ellipsis-vertical fa-lg float-end mt-3 me-2"></i></div> : ""}
        {(isConfiguration || data.templates.length > 1) ? <Nav tabs className="d-flex" style={navStyle} data-backimage={navStyle.hasImage || null} data-imageOpacity={navStyle.alpha || null}>
            {data.templates.map((template, index) => {
                var icon = "";
                var navItemStyle = {};
                var designInput = template.customDesign?.designInput;
                designInput = modelFctManager.prepareMergedDesign(template, designInput, "default_templateInput", true);
                if (designInput) {
                    Object.assign(navItemStyle, modelFctManager.setCustomBackground(designInput, data));

                    if (designInput.icon) icon = <i className={`fa ${designInput.icon.replace(/_/g, "-")}`}></i>;
                }

                data.countTabIndex++;
                var tabIndex = data.countTabIndex;
                template.tabIndex = tabIndex;
                var activeStyle = {};
                return (<NavItem key={tabIndex} className={`flex-fill text-center ${template.hidden ? "config-hidden" : ""}`} style={{ borderBottom: "3px solid " + navSelectedColor }}>
                    <NavLink href="#" className={`ctabnav ${(triggerSelection && triggerSelection() === template) ? "cdata-selected" : ""} ${selectedTab === tabIndex.toString() ? "active" : ""}`}
                        style={{ color: ((triggerSelection && triggerSelection() === template) ? navSelectedColor : navColor), ...navItemStyle, ...activeStyle }} data-backimage={navItemStyle.hasImage || null} data-imageOpacity={navItemStyle.alpha || null} onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                        setSelectedTab(tabIndex.toString());
                        if (triggerSelection) triggerSelection(template);
                    }} onMouseEnter={(e) => {
                        if (isConfiguration) {
                            if (e.target.classList.contains("ctabnav")) e.target.classList.add("tab-hover");
                            else e.target.closest(".ctabnav").classList.add("tab-hover");
                        }
                    }} onMouseLeave={(e) => {
                        if (isConfiguration) {
                            if (e.target.classList.contains("ctabnav")) e.target.classList.remove("tab-hover");
                            else e.target.closest(".ctabnav").classList.remove("tab-hover");
                        }
                    }}>
                        <div className="fragTools">
                            <div className="fragInfos" title={t("editor.type_template") + (template.bindPropResult ? (" | " + template.bindPropResult) : "")}>
                                {t("editor.type_template")} {(template.bindPropResult ? (" | " + template.bindPropResult) : "")}
                            </div>
                            <div className="fragShortcut">
                                <i className="fa fa-copy frag-clone"></i>
                                <i className="fa fa-pencil frag-edit"></i>
                                <i className="fa fa-trash frag-remove" onClick={() => {
                                    if (template.categories.length) {
                                        Swal.fire({
                                            icon: "question",
                                            title: "Suppression",
                                            html: "Êtes-vous sûr de vouloir supprimer cet élément ?<br/>(des éléments sont encore présents à l'intérieur)",
                                            showCancelButton: true,
                                            confirmButtonColor: "#28a745",
                                            cancelButtonColor: "#dc3545",
                                            confirmButtonText: "Oui",
                                            cancelButtonText: "Non"
                                        }).then((result) => {
                                            if (result.value) {
                                                data.templates = data.templates.filter(temp => temp !== template);
                                                setSelectedTab("1");
                                                if (triggerSelection) triggerSelection(data.templates[0]);
                                                setShouldRender(!shouldRender);
                                            }
                                        });
                                    }
                                    else {
                                        data.templates = data.templates.filter(temp => temp !== template);
                                        setSelectedTab("1");
                                        if (triggerSelection) triggerSelection(data.templates[0]);
                                        setShouldRender(!shouldRender);
                                    }
                                }}></i>
                            </div>
                        </div>
                        {icon} {template.title || ("TAB#" + tabIndex)}
                    </NavLink>
                </NavItem>);
            })}
            {isConfiguration ? <NavItem className="">
                <NavLink href="#" className={`p-0`}><Button className="btn-icon m-0" color="success" onClick={() => {
                    var newTemplate = {
                        objType: "template", title: "TAB#", categories: [
                            {
                                ...modelFctManager.dataModels["category"], bindPropResult: "extras.addedcategory-" + data.gridID + "-" + Math.floor(Math.random() * 1000000000),
                                headers: [
                                    {
                                        ...modelFctManager.dataModels["header"], bindPropResult: "extras.addedheader-" + data.gridID + "-" + Math.floor(Math.random() * 1000000000),
                                        groups: [{ ...modelFctManager.dataModels["group"], bindPropResult: "extras.addedgroup-" + data.gridID + "-" + Math.floor(Math.random() * 1000000000) }]
                                    }
                                ]
                            }
                        ], bindPropResult: "addedtemplate-" + Math.floor(Math.random() * 1000000000)
                    };
                    data.templates.push(newTemplate);
                    setSelectedTab((data.countTabIndex + 1).toString());
                    if (triggerSelection) triggerSelection(newTemplate);

                    setShouldRender(!shouldRender);
                }}><i className="fa fa-plus"></i></Button></NavLink>
            </NavItem> : ""}
        </Nav> : ""}
        <TabContent className="h-100" style={childStyle} data-backimage={childStyle.hasImage || null} data-imageOpacity={childStyle.alpha || null} activeTab={selectedTab}>{childs}</TabContent>
    </div>;
}